import * as React from 'react';
import { Input, Tooltip } from 'antd';
import StaticView from './StaticView';
import Limitations from 'common/components/Form/limitations';

// 渲染静态展示组件
export default class InputView extends React.Component<any> {

    changeHandler = (e: any) => {
        const { onChange, filter, limitations } = this.props;
        let value: any;
        if (limitations && limitations.length && limitations[0]) {
            limitations.map((limitation: any) => {
                value = Limitations()[limitation](e.target.value);
            });
        } else {
            value = e.target.value;
        }
        value = filter ? filter(value) : value;
        onChange && onChange(value);
    };

    blurHandler = () => {
        const { onBlur, value } = this.props;
        onBlur && onBlur(value);
    };

    staticViewRender = () => {
        const { value, placeholder, addonAfter, disabled, addonBefore, staticView, initialValue, copy, readOnly, link,
                maxLength, href, target, name, wrapBool, nameConfig, showName, showDecrypt, decryptConfig } = this.props;
        return (staticView && disabled || readOnly)
            ? <StaticView display={value || initialValue || '-'} copy={copy} link={link} href={href} wrap={wrapBool} target={target}
                          nameConfig={nameConfig} showName={showName} showDecrypt={showDecrypt}  decryptConfig={decryptConfig}/>
            : <Input placeholder={placeholder} defaultValue={initialValue || undefined} value={value || undefined}
                     disabled={disabled && !staticView}
                     addonBefore={addonBefore} onChange={this.changeHandler} onBlur={this.blurHandler}
                     maxLength={maxLength && Number(maxLength)}
                     addonAfter={addonAfter} name={name}/>;
    };

    render() {
        const { tooltip } = this.props;
        return (
            tooltip
                ? <Tooltip placement="topLeft" title={tooltip}>{this.staticViewRender()}</Tooltip>
                : this.staticViewRender()
        );
    }
}
